<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div class="row justify-content-center">
        <!-- 累積人流置頂 -->
        <div class="col-lg-5 col-sm-12">
          <ul
            class="list-group list-group-horizontal position-relative d-flex justify-content-center "
          >
            <li class="list-group-item border-0 bg-transparent p-1">

              <button
                href="#"
                class="bg-white border border-1 border-teal rounded-pill px-3 pt-1 pb-1 fw-bold default-purple shadow-sm d-flex align-items-center"
                >當日累積人流
                <p class="h5 text-cyan m-0 ms-1">{{this.dailyPeopleFlow}}人</p>
            </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2 mt-0">
      <div class="col">
        <div class="card card-clean h-100">
          <div
            class="card-header bg-white border-0 fw-bold text-indigo h5 my-0"
          >
            車流推估人流

          </div>
          <div class="card-body p-2 pt-0 pb-3">
            <popularScenicArea class="mb-3"></popularScenicArea>
            <div class="chart-description chart-description-btm">
              轄區內依各景區當日累計人流按比例呈現。
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card card-clean h-100">
          <div
            class="card-header bg-white border-0 fw-bold text-indigo h5 my-0"
          >
            當日分時車流推估人流
          </div>
          <div class="card-body p-3 pt-0 pb-3">
            <allScenicAreaPeopleFlow></allScenicAreaPeopleFlow>
            <div class="chart-description chart-description-btm">
              以分時呈現各停車場當日進入總車輛數推估人流，08時段為08~09時段的預估人流。
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card card-clean h-100">
          <div
            class="card-header bg-white border-0 fw-bold text-indigo h5 my-0"
          >
            停車場容留狀況
          </div>
          <div class="card-body p-2 pt-0 pb-5">
            <parkingAreastatus></parkingAreastatus>
            <div class="chart-description chart-description-btm ">
              各景區當日即時在園停車容留資訊。
              <div class="chart-description-sm ">
              【註】 停車容留率計算方式 = （進入車數 - 離場車數）÷ 停車位
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card card-clean h-100">
          <div
            class="card-header bg-white border-0 fw-bold text-indigo h5 my-0"
          >
            事件總覽
          </div>
          <div class="card-body px-2 py-1">
            <allemergencyEvent></allemergencyEvent>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import { postVehicleInTimeIntervalPerHour } from "../../api/eastCoastDataApi/ElkQuery/VehicleElk";


import allemergencyEvent from "../../components/allemergencyEvent.vue";
import parkingAreastatus from "../../components/parkingAreastatus.vue";
import allScenicAreaPeopleFlow from "../../components/allScenicAreaPeopleFlow.vue";
import popularScenicArea from "../../components/popularScenicArea.vue";

export default {
  components: {
    allemergencyEvent,
    parkingAreastatus,
    allScenicAreaPeopleFlow,
    popularScenicArea,
  },

  data(){
    return{
      dataInterval: null,
      dailyPeopleFlow: "",

      startTime: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      endTime: moment().endOf("day"), //統一為當下時:分:00\
      // startTime: "2025-02-05T00:00:00",
      // endTime: "2025-02-05T23:59:59", //統一為當下時:分:00\

      // startTime: "2022-07-26T16:55:55",
      // endTime: "2022-07-29T23:55:55",

      // startTime: "2023-04-03T00:00:00",
      // endTime: "2023-04-03T23:59:59",

      // startTime: "2023-09-04T16:55:55",
      // endTime: "2023-09-04T23:55:55",

      // startTime: "2023-09-24T00:00:00",
      // endTime: "2023-09-24T23:55:55",
      
      // startTime: "2023-01-10T00:00:00",
      // endTime: "2023-12-21T23:59:00",


    }
  },
  computed: {
    ...mapState("trafficFlow", { totalTrafficFlow: "totalTrafficFlow" }),
    ...mapState('elasticMonitor', {vehicleAndPeople: 'vehicleAndPeople'}),
    ...mapGetters('scenicArea', {myScenicAreaList: 'getMyScenicArea'})
  },
  methods: {
    async getVehicleAndPeople() {
      //所有景區累計人車流
      const condition = {
        sttime: moment().startOf("day").format(),
        endtime: moment().startOf("minute").format(),
        areas:  this.myScenicAreaList.map((s) => s.id),
        interval:"day"
      };
      let response = await postVehicleInTimeIntervalPerHour(condition);
      await this.getDailyPeopleFlow(response.data);
    },

    async getparkingAreastatus(){
      await this.$store.dispatch("elasticMonitor/getVehicleAndPeople");
    },

    async getDailyEmergencyEvents() {
      //緊急求救事件
      const condition = {
        //緊急求救查詢條件固定為 : 永遠顯示全時段未解除事件
        startTime: "2023-12-01T00:00:00",
        endTime: this.endTime,
        scenicAreaId: "",
        dismissStatus:2 //未解除
      };
    
      await this.$store.dispatch(
        "emergencyEvent/getEmergencyEvents",
        condition
      );


    },

    async getDailyDisasters() {
      // 今日天氣風險
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      await this.$store.dispatch("disasterMonitor/getAllDisaster", condition);

    },


    async getviolation() {
      //今日違規紀錄
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId:"", //查所有景區
        // type: 2  //只查 機車闖入
        type: []  //查機車與封閉闖入


      };
      await this.$store.dispatch('violation/getViolationData', condition)

    },

    async getControlHistory() {
      //今日管制紀錄
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: null,
      };
      await this.$store.dispatch('controlHistory/getControlHistoryByTimeInterval', condition)
   
    },

    async getParkingLimit() {
      //今日停車容留
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: null,
        warningLevel: CONST.PARKING_AREA_STATUS[2].status,
        passengerType:["vehicle"] //僅查詢四輪容留狀態 (小型車+大型車)
      };

      await this.$store.dispatch("parkingAvailabilityRate/getParkingAvailabilityRate", condition)
   
    },

    async getDeviceErrorList() {
      //今日設備異常
      const condition = {
        stTime: moment(this.startTime).format(),
        endTime: moment(this.endTime).format(),
        areaId: null,
        deviceType: "videoCamera",
        deviceStatus: -1 ,//保留 目前後端沒有用
        isNotify:true //發報僅顯示【已通報】的事件
      };

      await this.$store.dispatch("deviceError/getDeviceErrorData", condition)
  
    },

    async getIotEvent(){
      //今日公廁維運事件
      const condition={
        startTime: this.startTime,
        endTime: this.endTime,
        // startTime:"2024-01-25T00:00:00+08:00",
        // endTime:"2024-01-25T23:59:59+08:00",
        // scenicAreaId: this.selectedScenicAreaId,
        type:["odor","nilometer"],
      }
      await this.$store.dispatch("iotEvent/getIotEvent", condition);


    },




    async getAllData() {
      //  this.getVehicleAndPeople();
       this.getparkingAreastatus();
       this.getDailyEmergencyEvents();
       this.getDailyDisasters();
       this.getviolation();
       this.getControlHistory();
       this.getIotEvent();
       this.getParkingLimit();
       this.getDeviceErrorList();


    
    },

     async getDailyPeopleFlow(data) {

      const dailyPeopleFlowData = await data.map((d) => {
        return Math.round(d.totalPeopleFlow);
      });
      //相加每個人流
      this.dailyPeopleFlow = dailyPeopleFlowData.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);

    },
  },
  watch:{
    
    async myScenicAreaList(newData, oldData) {
      if (newData !== oldData) {
      //  this.getDailyPeopleList();
        await this.getVehicleAndPeople();
      }
    },
  },


  async mounted() {
    await this.getAllData();
    if (this.myScenicAreaList) await this.getVehicleAndPeople();
    //  this.getDailyPeopleFlow();
    this.dataInterval = setInterval(async () => {
      this.getVehicleAndPeople();
      this.getAllData();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval)
    this.dataInterval = null
  }


};
</script>
